import { render, staticRenderFns } from "./PatientAddDetailPolicy.vue?vue&type=template&id=b5102be0&scoped=true"
import script from "./PatientAddDetailPolicy.vue?vue&type=script&lang=js"
export * from "./PatientAddDetailPolicy.vue?vue&type=script&lang=js"
import style0 from "./PatientAddDetailPolicy.vue?vue&type=style&index=0&id=b5102be0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5102be0",
  null
  
)

export default component.exports